import { createSlice } from '@reduxjs/toolkit';

interface MapState {
    googleMapStatus: boolean;
}

const initialState: MapState = {
    googleMapStatus: true,
};

const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        setGoogleMapStatus: (state, action) => {
            state.googleMapStatus = action.payload;
        },
    },
});

export const { setGoogleMapStatus } = mapSlice.actions;

export default mapSlice.reducer;
